<template>
  <div
    class="modal fade createNewModal"
    id="AddModalTypeActeur"
    tabindex="-1"
    ref="addTypeActeurModalRef"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
        </div>
        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <Form ref="typeActeurForm" @submit="addTypeActeur" :validation-schema="typeActeurSchema">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Libellé  <span class="text-danger">*</span>
                  </label>
                  <Field name="libelle" type="text" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrez le libelle "/>
                  <ErrorMessage name="libelle" class="text-danger"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Description  <span class="text-danger">*</span>
                  </label>
                  <Field name="description" type="text" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrez le libelle "/>
                  <ErrorMessage name="description" class="text-danger"/>
                </div>
              </div>
            <button
              class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
              type="submit"
            >
            {{ btntext }}
            </button>
          </div>
        </Form>
        </div>
        <button
          type="button"
          class="btn-close shadow-none"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="resetValue()"
        ></button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { error , success, hideModal } from '../../utils/utils';
import { Modal } from 'bootstrap';
import Multiselect from '@vueform/multiselect'
import { TypeActeur } from '@/models/TypeActeur';

export default defineComponent({
    name: "AddModalTypeActeur",
    components: {
    Form,
    Field,
    ErrorMessage,
 
  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }){
    const typeActeurSchema = Yup.object().shape({
      libelle: Yup.string().required('Le Libellé est obligatoire'),
      description: Yup.string().required('La description est obligatoire'),

      
    });

    const typeActeurForm = ref<TypeActeur | null>(null);
    const addTypeActeurModalRef = ref<null | HTMLElement>(null);
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const title = ref("Ajoute une type d'Acteur ");
    const btntext = ref('Ajouter');
    


    watch(() => props.item, (newValue) => {
      getTypeActeur(newValue);
      isUPDATE.value = true;
      btnTitle();
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
         title.value = "Modifier un type d' Acteur";
         btntext.value = "Modifier";
      }else{
         title.value = "Ajouter un type d'Acteur";
         btntext.value = "Ajouter";
      }
    }

    const getTypeActeur = async (id: number) => {
      return ApiService.get("/typeActeur/"+id)
      .then(({ data }) => {
        const donnees = data.data;
        for (const key in donnees) {
          typeActeurForm.value?.setFieldValue(key, 
          (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
          );
        }
        emit('openmodal', addTypeActeurModalRef.value);

      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    }

    const addTypeActeur = async (values: any, typeActeurForm) => {
      values = values as TypeActeur;
      if(isUPDATE.value){
        ApiService.put("/typeActeur/"+values.id,values)
        .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              typeActeurForm.resetForm();
              hideModal(addTypeActeurModalRef.value);
              isUPDATE.value=false;
              btnTitle();
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }else{
        ApiService.post("/typeActeur",values)
        .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);
              typeActeurForm.resetForm();
              hideModal(addTypeActeurModalRef.value);
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isUPDATE.value=false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };

    return { 
    typeActeurSchema,
      addTypeActeurModalRef,
      addTypeActeur,
      typeActeurForm,
      title,btntext,resetValue,
      
    };
  },
});
</script>